export default __webpack_public_path__ + "static/media/guiaBeneficiario.183a122c.png";